import Template from '../../component/Template.js';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useAuth from '../../component/useAuth.js';
import Select from 'react-select'; //04-03-2024-multiselect

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Api from '../../component/Api.js';

export default function CollegeUserSeatMapping() {


  const [errors, setErrors] = useState({});
  const [userTypeListData, setUserTypeListData] = useState([]);
  const [lastUserId, setLastUserId] = useState([]);
  const [selectedUserType, setSelectedUserType] = useState(null);
  const [userTypeId, setUserTypeId] = useState([]);
  const [username, setUsername] = useState('');
  const [pfno, setPfno] = useState('');
  const [email, setEmail] = useState('');
  const [userId, setUserId] = useState('');
  const [password, setPassword] = useState('');

  const [isFirstSubmit, setFirstSubmit] = useState(false);


  const [passwordStrength, setPasswordStrength] = useState("");

  const { http } = Api();
  const navigate = useNavigate();

  const isAuth = useAuth();
  if (isAuth === false) {
    navigate("/admin/");
  }

  useEffect(() => {
    const getUserTypeList = async () => {
      http.get('/Admin/getUserTypeList')
        .then((response) => {
          setUserTypeListData(response.data.result);
          setLastUserId(response.data.lastuserid);
        }).catch((error) => {
          const status = error.response?.data?.http_status;
          const message = error.response?.data?.message || "An error occurred";

          if (status === 500 || error.response?.data?.status_code === "ERR5") {
            toast.error(message);
          } else if (status === 403 && error.response?.data?.status_code === "ERR37") {
            toast.error("Invalid Token");
            setTimeout(() => navigate("/admin/"), 5000);
          } else {
            toast.error(message);
          }
        });
    };

    getUserTypeList();
  }, []);

  useEffect(() => {
    // Trigger email and userId update whenever PF No or User Type is updated
    if (pfno && pfno.length === 4 && selectedUserType) {
      const generatedEmail = `${pfno}@mgu.ac.in`;
      const generatedUserId = `MGU${selectedUserType.usertypecode}${pfno}`;
      setEmail(generatedEmail);
      setUserId(generatedUserId);
    } else if (pfno === '') {
      setEmail('');
      setUserId('');
    }

  }, [pfno, selectedUserType]); // Depend on pfno and selectedUserType

  const handleUserTypeChange = (selectedOption) => {
    setSelectedUserType(selectedOption);
    setUserTypeId(selectedOption.value);
  };

  const handlePfnoChange = (e) => {
    const { value } = e.target;
    if (/^\d{0,4}$/.test(value)) { // Ensure it's a 4-digit number
      setPfno(value);
    } else {
      toast.error('Please enter a valid 4-digit PF number.');
    }
  };

  const validateForm = () => {
    let hasError = false;
    let updatedErrors = {};

    if (!username) {
      updatedErrors.username = 'User Name is required.';
      hasError = true;
    }

    if (!selectedUserType) {
      updatedErrors.userType = 'User Type is required.';
      hasError = true;
    }

    if (!pfno) {
      updatedErrors.pfno = 'PF No. is required.';
      hasError = true;
    }

    if (!email.trim()) {
      updatedErrors.email = 'Email is required.';
      hasError = true;
    } else if (!/\S+@\S+\.\S+/.test(email)) {
      updatedErrors.email = 'Enter a valid email address.';
      hasError = true;
    }

    if (!userId.trim()) {
      updatedErrors.userId = 'User ID is required.';
      hasError = true;
    }

    if (!password) {
      updatedErrors.password = 'Password is required.';
      hasError = true;
    }

    setErrors(updatedErrors);
    return !hasError;
  };


  const handleCancel = () => {
    setFirstSubmit(!isFirstSubmit);
    window.location.reload();
  }

  const cancelForm = () => {
    window.location.reload();
  };

  const generatePassword = () => {
    const length = 12;
    const charset =
      "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$";
    let newPassword = "";
    for (let i = 0; i < length; i++) {
      newPassword += charset.charAt(Math.floor(Math.random() * charset.length));
    }
    setPassword(newPassword);
    evaluateStrength(newPassword);
  };
  const evaluateStrength = (password) => {
    if (password.length >= 12) {
      setPasswordStrength("Very Strong");
    } else if (password.length >= 8) {
      setPasswordStrength("Strong");
    } else {
      setPasswordStrength("Weak");
    }
  };
  const copyToClipboard = () => {
    if (password) {
      navigator.clipboard.writeText(password).then(
        () => toast.success("Password copied to clipboard!"),
        () => toast.error("Failed to copy password.")
      );
    }
    else {
      toast.error("Please generate password");
    }
  };

  const handlefirstsubmit = () => {
    if (validateForm()) {
      //e.preventDefault();
      const payloads = {
        uname: username,
        user_id: userId,
        user_type: userTypeId,
        email: email,
        password: password
      };
      const saveNewUserData = () => {
        http.post('/Admin/saveNewUserData', payloads).then((response) => {
        
          if (response.data.status_code === 'MSG1') {
            toast.success("User data inserted successfully");
            setTimeout(() => {
              cancelForm();
            }, 3000);

          }
          else {
            toast.error("Failed to save User Data");
          }
        }).catch((error) => {
          const status = error.response?.data?.http_status;
          const message = error.response?.data?.message || "An error occurred";

          if (status === 500 || error.response?.data?.status_code === "ERR5") {
            toast.error(message);
          } else if (status === 403 && error.response?.data?.status_code === "ERR37") {
            toast.error("Invalid Token");
            setTimeout(() => navigate("/admin/"), 5000);
          } else {
            toast.error(message);
          }
        });
      };
      saveNewUserData();
    }
    else {
      toast.error("Please fill mandatory fields");
    }
  };
  const customStyles = {
    menu: (provided) => ({
      ...provided,
      maxHeight: '200px',
      overflowY: 'auto',
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: '180px',
      overflowY: 'auto',
      scrollbarWidth: 'thin',
      scrollbarColor: '#888 #f1f1f1',
    }),

    multiValue: (provided) => ({
      ...provided,
      '&::-webkit-scrollbar': {
        width: '8px',
      },
      '&::-webkit-scrollbar-track': {
        background: '#f1f1f1',
      },
      '&::-webkit-scrollbar-thumb': {
        background: '#888',
        borderRadius: '4px',
      },
      '&::-webkit-scrollbar-thumb:hover': {
        background: '#555',
      },
    }),
  };

  return (
    <>
      <ToastContainer />
      <Template>


        <div className="container-fluid">
          <div className="row">
            <div className="table-responsive">
              <div className="card">
                <div className="col-md-12">
                  <div className="card-header">
                    <div className="py-3 d-flex justify-content-between align-items-center">
                      <h5>Add Users</h5>
                    </div>
                  </div>
                  <div className="card-body">
                    <div className="table-responsive">
                      <div className="col-md-12 txt-aln pdg14">
                        <div className="row">
                          <div className="col">
                            <div className="row">
                              <label className="col-md-5 txt-aln-lft">User Name <span className="errorclr">*</span></label>
                              <div className="col-md-7">
                                <input type="text" className="form-control input-air-primary" name="username" value={username} onChange={(e) => setUsername(e.target.value)}
                                />
                                {errors.username && <p className="text-danger">{errors.username}</p>}
                              </div>
                            </div>

                            <div className="row">
                              <label className="col-md-5 txt-aln-lft">PF No.<span className="errorclr">*</span></label>
                              <div className="col-md-7">
                                <input className="form-control input-air-primary" type="pfno" name="pfno" value={pfno} onChange={handlePfnoChange} />
                                {errors.pfno && <p className="text-danger">{errors.pfno}</p>}
                              </div>
                            </div>

                            <div className="row">
                              <label className="col-md-5 txt-aln-lft">User Type <span className="errorclr">*</span></label>
                              <div className="col-md-7">
                                <Select
                                  id="userType"
                                  name="userType"
                                  maxMenuHeight={200}
                                  menuPlacement="auto"
                                  styles={customStyles}
                                  className="form-control ht"
                                  options={userTypeListData.map(usertype => ({
                                    value: usertype.usertype_id,
                                    label: usertype.user_type_desc,
                                    usertypecode: usertype.user_type_code,
                                    // seat_code: usertype.seatCd,
                                  }))}
                                  value={selectedUserType}
                                  onChange={handleUserTypeChange}
                                />
                                {errors.userType && <p className="text-danger">{errors.userType}</p>}
                              </div>
                            </div>

                            <div className="row">
                              <label className="col-md-5 txt-aln-lft">Email ID<span className="errorclr">*</span></label>
                              <div className="col-md-7">
                                <input className="form-control input-air-primary" type="email" name="email" value={email} onChange={(e) => setEmail(e.target.value)} />
                                {errors.email && <p className="text-danger">{errors.email}</p>}
                              </div>
                            </div>

                            <div className="row">
                              <label className="col-md-5 txt-aln-lft">User ID <span className="errorclr">*</span></label>
                              <div className="col-md-7">
                                <input className="form-control input-air-primary" type="text" name="userId" value={userId} onChange={(e) => setUserId(e.target.value)} readOnly />
                                {errors.userId && <p className="text-danger">{errors.userId}</p>}
                              </div>
                            </div>
                            <div className="row">
                              <label className="col-md-5 txt-aln-lft">
                                Password<span className="errorclr">*</span>
                              </label>
                              <div className="col-md-7">
                                <div className="position-relative">
                                  <div className="d-flex align-items-center" style={{ gap: "10px" }}>
                                    <input
                                      className="form-control input-air-primary"
                                      type="text"
                                      name="password"
                                      value={password}
                                      readOnly
                                      onChange={(e) => setPassword(e.target.value)}
                                      placeholder="Generated Password"
                                      style={{ flex: 2 }}
                                    />

                                    <button
                                      type="button"
                                      className="reload-btn "
                                      style={{
                                        padding: "0.25rem 0.5rem",
                                        fontSize: "17px"
                                      }}
                                      onClick={generatePassword}
                                      title="Generate new password"
                                    >
                                      <i className="fa fa-refresh" aria-hidden="true"></i>
                                    </button>

                                    <button
                                      type="button"
                                      className="reload-btn-c "
                                      style={{
                                        padding: "0.25rem 0.5rem",
                                        fontSize: "17px"
                                      }}
                                      onClick={copyToClipboard}
                                      title="Copy password"
                                    >Copy</button>
                                  </div>

                                  <small
                                    className={`password-strength text-${passwordStrength === "Very Strong"
                                      ? "success"
                                      : passwordStrength === "Strong"
                                        ? "warning"
                                        : "danger"
                                      }`}
                                  >
                                    {passwordStrength || (
                                      <span>
                                        Please Click <i className="fa fa-refresh reload-i" aria-hidden="true"></i> to get password
                                      </span>
                                    )}
                                    {errors.password && <p className="text-danger">{errors.password}</p>}
                                  </small>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div>
                          <button className="btn btn-primary me-3" type="submit" onClick={handlefirstsubmit}>Submit</button>
                          <input className="btn btn-light" type="reset" style={{border:'2px solid black'}} value="Cancel" onClick={cancelForm} />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Template>
    </>
  );
}
